import Instance from "../../../../Axios";

// New Actions for the app

const GetWorkPermitStatus = () => async (dispatch) => {
  await Instance()
    .get(`/construcoes/workpermits/status`)
    .then(({ data }) => {
      // console.log(data);
      dispatch({ type: "GET_WORK_PERMIT_STATUS", payload: data.yData });
      // setObraSelecionada(data.yData[0]);
    })
    .catch((err) => {
      console.log(err);
    });
};

export default GetWorkPermitStatus;
